class FooterController {
  public year : number;

  constructor() {
    this.year = new Date().getFullYear();
  }
}

export const footer: angular.IComponentOptions = {
  template: require('./footer.html'),
  controller: FooterController
};



// WEBPACK FOOTER //
// ./src/app/layout/footer.ts